<template>
  <el-form ref="form" label-width="120px" :model="pointInfo" v-loading="loading">
    <div class="text-right mb-10px" v-show="showFlow">
      <el-button size="small" @click.stop="$refs.flowDetails.showDialog = true">查看进度</el-button>
    </div>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动名称" prop="jobName">
          <el-input
            v-model="pointInfo.jobName"
            placeholder="请输入作业活动名称"
            maxlength="50"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动类型" prop="jobActivityTypeText">
          <el-input
            v-model="pointInfo.jobActivityTypeText"
            placeholder="请输入作业活动类型"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动内容" prop="jobContent">
          <el-input
            v-model="pointInfo.jobContent"
            placeholder="请输入作业活动内容"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动编号" prop="jobNo">
          <el-input
            v-model="pointInfo.jobNo"
            placeholder="请输入作业活动编号"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业实施单位" prop="jobImplementationUnitText">
          <el-input
            v-model="pointInfo.jobImplementationUnitText"
            placeholder="请输入作业实施单位"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动区域" prop="jobActivityAreaText">
          <el-input
            v-model="pointInfo.jobActivityAreaText"
            placeholder="请输入作业活动区域"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="涉及设备设施" prop="equipmentText">
          <el-input
            v-model="pointInfo.equipmentText"
            placeholder="请输入涉及设备设施"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动频率" prop="jobActivityFrequencyText">
          <el-input
            v-model="pointInfo.jobActivityFrequencyText"
            placeholder="请输入作业活动频率"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <FlowDetails :taskId="taskId" ref="flowDetails" />
  </el-form>
</template>

<script>
import { JobSourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import FlowDetails from './FlowDetails'

const jobSourcesDangerIdentifyApi = new JobSourcesDangerIdentifyApi()

export default {
  name: 'business-job-form',
  components: {
    FlowDetails,
  },
  props: {
    taskId: {
      type: String,
      default: null,
    },
    showFlow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      pointInfo: {
        jobActivityTypeText: '',
        jobName: '',
        jobContent: '',
        jobNo: '',
        jobImplementationUnitText: '',
        jobActivityAreaText: '',
        equipmentText: '',
        jobActivityFrequencyText: '',
      },
      areaList: [],
      jobActivityFrequencyList: [],
      jobActivityTypeList: [],
      deviceList: [],
      disabled: true,
    }
  },
  methods: {
    async getPointInfo() {
      this.loading = true
      const [err, res] = await jobSourcesDangerIdentifyApi.getJobActivityInfo({
        sourcesDangerRecognitionPlanTaskId: this.taskId,
      })
      if (!err) {
        const { creationTime, ...otherData } = res
        this.pointInfo = {
          ...otherData,
        }
      }
      this.loading = false
    },
  },
  created() {
    // 获取风险点基本信息
    this.getPointInfo()
  },
}
</script>

<style lang="scss" scoped></style>
